const state = {
  addingToCart: false,
};

if (Spree.order_total !== undefined || Spree.order_total !== null) {
  state.orderTotal = Spree.order_total;
}

// Store the previously applied coupon code
if (Spree.coupon_code) {
  state.defaultCouponCode = Spree.coupon_code;
  state.applyCouponCode = Spree.coupon_code !== undefined;
}

export default state;
